// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Tuple2 = require("relude/src/Relude_Tuple2.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");

function makeArg(key, value) {
  return {
          key: key,
          value: value
        };
}

function makeArg$1(param) {
  return Relude_Function.uncurry2(makeArg, param);
}

var delimiter = "&";

var assignmentDelimiter = "=";

var startChar = "?";

var fromList = Relude_List.map(function (param) {
      return {
              key: param[0],
              value: param[1]
            };
    });

function fromString(str) {
  var param = Relude_Option.fold([
        "",
        str
      ], (function (__x) {
          return Relude_String.splitAt(__x, str);
        }), Relude_String.indexOf(startChar, str));
  return Relude_List.map(makeArg$1)(Relude_List.mapOption((function (queryArg) {
                    var param = Relude_String.splitList(assignmentDelimiter, queryArg);
                    if (!param) {
                      return ;
                    }
                    var match = param.tl;
                    if (match) {
                      return Relude_Option.pure([
                                  param.hd,
                                  match.hd
                                ]);
                    }
                    
                  }), Relude_String.splitList(delimiter, param[1])));
}

var partial_arg = Relude_List.foldLeft((function (prim, prim$1) {
        return prim + prim$1;
      }), "");

var partial_arg$1 = Relude_List.map(function (param) {
      return param[0] + (assignmentDelimiter + param[1]);
    });

function partial_arg$2(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_List.mapOption((function (param) {
                              return Curry._2(Relude_Option.mapTuple2, Relude_Tuple2.make, [
                                          Relude_String.toNonWhitespace(param.key),
                                          Relude_String.toNonWhitespace(param.value)
                                        ]);
                            }), param);
              }), partial_arg$1, param);
}

function partial_arg$3(param) {
  return Relude_Globals.$great$great(partial_arg$2, (function (param) {
                return Relude_List.intersperse(delimiter, param);
              }), param);
}

function partial_arg$4(param) {
  return Relude_Globals.$great$great(partial_arg$3, partial_arg, param);
}

function partial_arg$5(param) {
  return Relude_Globals.$great$great(partial_arg$4, Relude_String.toNonWhitespace, param);
}

function toString(param) {
  return Relude_Globals.$great$great(partial_arg$5, (function (param) {
                return Relude_Option.fold("", (function (param) {
                              return startChar + param;
                            }), param);
              }), param);
}

function get(keyToFind) {
  var partial_arg = Relude_List.map(function (param) {
        return param.value;
      });
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_List.keep((function (param) {
                                return Relude_String.eq(keyToFind, param.key);
                              }), param);
                }), partial_arg, param);
  };
}

var QueryArgs = {
  makeArg: makeArg$1,
  delimiter: delimiter,
  assignmentDelimiter: assignmentDelimiter,
  startChar: startChar,
  fromList: fromList,
  fromString: fromString,
  toString: toString,
  get: get
};

function toUrl(param) {
  return Relude_List.foldLeft((function (prim, prim$1) {
                  return prim + prim$1;
                }), "")(Relude_List.intersperse("/", param.path)) + Curry._1(toString, param.queryArgs);
}

function getArg(key, param) {
  return get(key)(param.queryArgs);
}

function prepend(param, param$1) {
  return {
          path: Curry._2(Relude_List.concatNamed, param$1.path, param.path),
          queryArgs: Curry._2(Relude_List.concatNamed, param$1.queryArgs, param.queryArgs)
        };
}

function fromReactRouterUrl(param) {
  return {
          path: param.path,
          queryArgs: fromString(param.search)
        };
}

var UrlParts_empty = {
  path: /* [] */0,
  queryArgs: /* [] */0
};

var UrlParts = {
  empty: UrlParts_empty,
  toUrl: toUrl,
  getArg: getArg,
  prepend: prepend,
  fromReactRouterUrl: fromReactRouterUrl
};

exports.QueryArgs = QueryArgs;
exports.UrlParts = UrlParts;
/* fromList Not a pure module */
